module.exports = __webpack_public_path__ + "static/media/espana.b13b4bda.png";